import { useTranslation } from 'react-i18next';
import { CardIcon } from '@components/Pages/AnalyticsPage/CardIcon';
import classes from './FloorStatsHeader.module.css';

export interface FloorStats {
  totalPersonnel: number;
  activities: number;
  safetyEvents: number;
  equipment: number;
}

interface IFloorStatsHeaderProps {
  floorNick: string;
  areaNicks: string[];
  stats: FloorStats;
}

export function FloorStatsHeader(props: IFloorStatsHeaderProps) {
  const { t } = useTranslation();
  const { floorNick, areaNicks, stats } = props;
  return (
    <header className={classes.root}>
      <div className={classes.floor}>
        <div className={classes.icon}>
          <CardIcon name="pin" size={18} />
        </div>
        <div>
          <div className={classes.floorName}>{floorNick}</div>
          <div className={classes.areas}>{areaNicks.join(' | ')}</div>
        </div>
      </div>
      <div className={classes.stat}>
        <div className={classes.statLabel}>{t('reports.observeLocation.stats.totalPersonnel')}</div>
        <div className={classes.statValue}>{stats.totalPersonnel}</div>
      </div>
      <div className={classes.stat}>
        <div className={classes.statLabel}>{t('reports.observeLocation.stats.activities')}</div>
        <div className={classes.statValue}>{stats.activities}</div>
      </div>
      <div className={classes.stat}>
        <div className={classes.statLabel}>{t('reports.observeLocation.stats.safetyEvents')}</div>
        <div className={classes.statValue}>{stats.safetyEvents}</div>
      </div>
      <div className={classes.stat}>
        <div className={classes.statLabel}>{t('reports.observeLocation.stats.equipment')}</div>
        <div className={classes.statValue}>{stats.equipment}</div>
      </div>
    </header>
  );
}
